import $ from 'jquery';
import { breakpoints } from './_site';
require('chart');

let timeout = {};
let charts = [];

export const createBarChart = ($el, data, extraOptions) => {
    create($el, 'bar', data, extraOptions);
};
export const createLineChart = ($el, data, extraOptions) => {
    create($el, 'line', data, extraOptions);
};
export const create = ($el, type, data, extraOptions) => {
    let options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    },
                },
            ],
        },
    };

    if (typeof extraOptions != 'undefined' && extraOptions) {
        options = {
            ...options,
            extraOptions,
        };
    }

    charts.push(
        new Chart($el, {
            type: type,
            data: data,
            options: options,
        })
    );
};
export const resize = () => {
    var $window = $(window),
        widthProportion,
        heightProportion;

    // md
    if ($window.width() < breakpoints.md) {
        widthProportion = $window.width();
        heightProportion = widthProportion;
    } else {
        widthProportion = $window.width();
        heightProportion = 400;
    }

    for (let i = 0; i < charts.length; i++) {
        let chart = charts[i];
        chart.canvas.parentNode.style.height = widthProportion;
        chart.canvas.parentNode.style.width = heightProportion;
        chart.resize();
    }
};
export const createDemos = () => {
    const barData = {
        labels: ['January 2019', 'February 2019', 'March 2019', 'April 2019'],
        datasets: [
            {
                label: 'Monthly Sales',
                data: [83500.1, 89315.33, 96135.28, 105461.5],
                backgroundColor: ['#FAF1C1', '#BAE2EF', '#E3C4C4', '#CEE0D1'],
            },
        ],
    };
    const lineData = {
        labels: [
            'October 2018',
            'November 2018',
            'December 2018',
            'January 2019',
            'February 2019',
            'March 2019',
            'April 2019',
        ],
        datasets: [
            {
                label: 'Unit 1',
                data: [650, 590, 800, 810, 656, 550, 409],
                fill: false,
                borderColor: '#FAF1C1',
                lineTension: 0.4,
            },
            {
                label: 'Unit 2',
                data: [350, 490, 630, 510, 760, 950, 500],
                fill: false,
                borderColor: '#BAE2EF',
                lineTension: 0.4,
            },
            {
                label: 'Unit 3',
                data: [475, 290, 330, 456, 789, 810, 777],
                fill: false,
                borderColor: '#E3C4C4',
                lineTension: 0.4,
            },
            {
                label: 'Unit 4',
                data: [150, 390, 230, 410, 351, 571, 670],
                fill: false,
                borderColor: '#CEE0D1',
                lineTension: 0.4,
            },
        ],
    };

    if ($('#reportChart').length) {
        createBarChart($('#reportChart'), barData);
    }
    if ($('#reportChartLine').length) {
        createLineChart($('#reportChartLine'), lineData);
    }
};
export const binds = () => {
    createDemos();

    // ---------------- window events
    $(window).on('resize.chart', function() {
        clearTimeout(timeout.chartResize);
        timeout.chartResize = setTimeout(function() {
            resize();
        }, 100);
    });
    $(window).triggerHandler('resize.chart');
};
